import {InsuranceVehicle, InsuranceVehicleV2} from '@dms/api/finance';

// Determines shape of Insurance Vehicle V2 object, which has mandatory sellingPrice property with non-empty value
// Type guard forces typescript to treat vehicle as InsuranceVehicleV2 if sellingPrice is present, so functions that expected InsuranceVehicle can be used with InsuranceVehicleV2 safely
// This typeguard means to be extendable if shape changes in the future
export const isInsuranceVehicleV2 = (
  vehicle: InsuranceVehicle | InsuranceVehicleV2 | null
): vehicle is InsuranceVehicleV2 => Boolean(vehicle?.sellingPrice);
